export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [10,[2],[3]],
		"/_marketing": [44,[9]],
		"/_marketing/case-study": [45,[9]],
		"/_marketing/fellows": [46,[9]],
		"/_marketing/responders": [47,[9]],
		"/_marketing/special-projects": [48,[9]],
		"/_marketing/stewards": [49,[9]],
		"/(gateway)/accept": [34,[7]],
		"/(app)/admin": [11,[2,4],[3]],
		"/(app)/admin/broadcast": [12,[2,4],[3]],
		"/(app)/admin/observations": [13,[2,4],[3]],
		"/(app)/admin/observations/[id]": [14,[2,4],[3]],
		"/(app)/admin/organizations": [15,[2,4,5],[3]],
		"/(app)/admin/organizations/[id]": [16,[2,4,5],[3]],
		"/(app)/admin/session": [17,[2,4],[3]],
		"/(app)/admin/species": [18,[2,4],[3]],
		"/(app)/admin/species/[id]": [19,[2,4],[3]],
		"/(app)/admin/system": [20,[2,4],[3]],
		"/(app)/admin/users": [21,[2,4],[3]],
		"/(app)/admin/users/[id]": [22,[2,4],[3]],
		"/(app)/admin/whitelist": [23,[2,4],[3]],
		"/(device)/authorize": [33,[6]],
		"/(legal)/delete-account": [41,[8]],
		"/(gateway)/invite/accept": [35,[7]],
		"/(app)/jobs": [24,[2],[3]],
		"/(app)/jobs/[id]": [25,[2],[3]],
		"/(gateway)/login": [36,[7]],
		"/(app)/observations": [26,[2],[3]],
		"/(app)/observations/[id]": [27,[2],[3]],
		"/(app)/organization": [28,[2],[3]],
		"/(app)/organization/create": [29,[2],[3]],
		"/(gateway)/pending": [37,[7]],
		"/(legal)/privacy-policy": [42,[8]],
		"/(app)/properties": [30,[2],[3]],
		"/(app)/properties/[id]": [31,[2],[3]],
		"/(gateway)/reset": [38,[7]],
		"/(app)/settings": [32,[2],[3]],
		"/(gateway)/signup": [39,[7]],
		"/(legal)/terms-of-service": [43,[8]],
		"/(gateway)/verify": [40,[7]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';